exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nsvg {\r\n    fill: #000;\n}\n.profile_image-edit svg {\r\n    fill: var(--secondary-background);\n}\n.profile_image-edit:hover svg {\r\n    fill: #0f90bb;\n}\n.trip-detail-component .profile-info--ratings svg {\r\n    display: inline;\r\n    margin-right: 0.4em;\r\n    vertical-align: middle;\r\n    fill: #fff;\n}\r\n", ""]);

// exports
